import React from 'react';
import { SelectBoxOption } from '../../SelectBox.types.';
import { Checkbox } from '@round/ui-kit';
import Option, { OptionProps } from '../Option/Option';

type CheckboxOptionProps<T extends SelectBoxOption> = Omit<OptionProps<T>, 'renderRight'> & {
    checked?: boolean;
    disabled?: boolean;
};

const CheckboxOption = <T extends SelectBoxOption>({ checked, disabled, ...props }: CheckboxOptionProps<T>) => {
    return (
        <Option
            {...props}
            disabled={disabled}
            renderRight={() => <Checkbox disabled={disabled} value={Boolean(checked)} />}
        />
    );
};

export default CheckboxOption;
